/** Dispatched when a modal/dialog takes focus so App.vue can close header nav menus. */
export const CLOSE_HEADER_DROPDOWNS_EVENT = 'tpop:close-header-dropdowns'

export function closeHeaderDropdowns(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(CLOSE_HEADER_DROPDOWNS_EVENT))
}
